import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import Aggregator from "./aggregator";
import Bank from "./bank";
import { oneBranchHasPermission } from "src/utils";
import { ForAccountantPermissions } from "src/constants/permissions";
import NoAccessPage from "src/pages/no-access";

interface TabProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: Readonly<TabProps>) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3 }} height="40px">
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const MatchingTabs = () => {
  const [value, setValue] = useState(0);
  const { t } = useTranslation("matching");

  const labels = [t("aggregator"), t("bank")];

  const viewAggs = oneBranchHasPermission(
    ForAccountantPermissions.viewAggregators,
  );
  const viewBank = oneBranchHasPermission(ForAccountantPermissions.viewBanks);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Tabs value={value} onChange={handleChange}>
        {labels.map((label, index) => (
          <Tab
            disableRipple
            key={`${index}_${label}`}
            label={label}
            {...a11yProps(index)}
          />
        ))}
      </Tabs>

      <Box>
        <CustomTabPanel value={value} index={0}>
          {viewAggs ? <Aggregator /> : <NoAccessPage />}
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1}>
          {viewBank ? <Bank /> : <NoAccessPage />}
        </CustomTabPanel>
      </Box>
    </Box>
  );
};

export default MatchingTabs;
